/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import Button from "../GlobalComponents/Button";

const Info = () => (
  <div css={styles} className="info">
    <p>We provide rooms for students as well as working professionals..</p>
    <p>Single and double rooms Available</p>
    <h1>
      LOOKING FOR HOSTEL?  
      <span> CALL NOW</span>
    </h1>
    <Button text="+919450-141680"/>
  </div>
);

const styles = css`
  width: 100%;
  max-width: 900px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  text-align: center;
  color: #fff;
  p {
    font-size: 12px;
    color:yellow;
    line-height: 1;
    padding:4px;
    margin:4px 4px;
    font-weight: 900;
    letter-spacing: 1.7px;
  }
  h1 {
    font-size: 45px;
    line-height: 1;
    font-weight: 900;
    margin: 36px 0;
    span {
    
      color: #ed563b;
    }
  }
  .btn {
    padding: 14px 16px;
    border-radius: 5px;
  }
  @media (max-width: 1000px) {
    h1 {
      font-size: 30px;
    }
  }
`;

export default Info;
